module.exports = __webpack_public_path__ + "images/d4c5cd0c94cd31e70b05837c11a9ef52-GIR logo.png";